// src/components/TeslimAkisModallar.js
// Araç teslim akışı için zorunlu modal bileşeni.
// K2/K3 (Faz 6): Garanti kartı adımı kaldırıldı — akış TEK adım (teslim notları).

import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Typography, Alert
} from '@mui/material';

// Teslim Notları Modalı (Zorunlu - tek ve son adım)
export const TeslimNotlariModal = ({ open, onClose, onConfirm, aracPlaka }) => {
    const [notlar, setNotlar] = useState('');
    const [error, setError] = useState('');
    const [kaydediliyor, setKaydediliyor] = useState(false);

    const handleConfirm = async () => {
        if (!notlar.trim()) {
            setError('Teslim notları zorunludur. Lütfen doldurun.');
            return;
        }
        setKaydediliyor(true);
        try {
            await onConfirm(notlar);
            setNotlar('');
            setError('');
        } catch (e) {
            // Yazma başarısızsa modal KAPANMAZ ve notlar korunur.
            setError(e?.message || 'Teslim kaydedilemedi. Lütfen tekrar deneyin.');
        } finally {
            setKaydediliyor(false);
        }
    };

    const handleClose = () => {
        if (kaydediliyor) return;
        setNotlar('');
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Teslim Notları
                <Typography variant="body2" color="text.secondary" component="div">
                    {aracPlaka} plakalı araç için
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Alert severity="info" sx={{ mb: 2 }}>
                    Araç teslim edilmeden önce teslim notlarını girmeniz zorunludur.
                </Alert>
                <TextField
                    autoFocus
                    label="Teslim Notları *"
                    multiline
                    rows={4}
                    fullWidth
                    value={notlar}
                    onChange={(e) => {
                        setNotlar(e.target.value);
                        if (error) setError('');
                    }}
                    error={!!error}
                    helperText={error || "Araç durumu, yapılan işlemler, müşteriye iletilen bilgiler vb."}
                    placeholder="Örn: Araç temiz teslim edildi. PPF kaplaması tamamlandı. Müşteriye bakım talimatları verildi."
                />
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose} color="inherit" disabled={kaydediliyor}>İptal</Button>
                <Button onClick={handleConfirm} variant="contained" color="success" disabled={kaydediliyor}>
                    {kaydediliyor ? 'Kaydediliyor…' : 'Teslimi Tamamla'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
